export const Config = {
  NDX_ACCOUNTS_SERVICE_URL: import.meta.env.NDX_ACCOUNTS_SERVICE_URL,
  MODE: import.meta.env.MODE,
  VITE_RELEASE: import.meta.env.VITE_RELEASE
};

export type ConfigType = typeof Config;
